function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripadvisorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 155 94",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 155,
    height: 94,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.48,18C106.386,16.564 110.5,15.774 114.66,15.66C103.58,10.66 91.04,8.19 77.14,8.19C64.232,8.066 51.431,10.556 39.51,15.51C59.368,15.928 75.847,31.562 77.31,51.37C78.426,36.3 88.296,23.214 102.48,18",
    style: {
      fill: "rgb(248,196,15)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,41.28C115.817,41.28 115.813,41.28 115.81,41.28C108.931,41.28 103.27,46.941 103.27,53.82C103.27,60.699 108.931,66.36 115.81,66.36C122.689,66.36 128.35,60.699 128.35,53.82C128.35,53.817 128.35,53.813 128.35,53.81C128.339,46.94 122.69,41.291 115.82,41.28M115.82,60.28C115.813,60.28 115.807,60.28 115.8,60.28C112.267,60.28 109.36,57.373 109.36,53.84C109.36,50.307 112.267,47.4 115.8,47.4C119.333,47.4 122.24,50.307 122.24,53.84C122.24,53.843 122.24,53.847 122.24,53.85C122.24,57.374 119.344,60.275 115.82,60.28",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.19,25.31C93.081,29.774 84.991,41.379 84.991,54.284C84.991,57.941 85.641,61.57 86.91,65C91.384,77.104 102.989,85.187 115.893,85.187C132.845,85.187 146.793,71.238 146.793,54.287C146.793,37.336 132.845,23.387 115.893,23.387C112.241,23.387 108.617,24.035 105.19,25.3M115.82,72.93C115.817,72.93 115.813,72.93 115.81,72.93C105.321,72.93 96.69,64.299 96.69,53.81C96.69,43.321 105.321,34.69 115.81,34.69C126.299,34.69 134.93,43.321 134.93,53.81C134.914,64.289 126.299,72.908 115.82,72.93",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.26,41.28C38.25,41.28 38.24,41.28 38.23,41.28C31.351,41.28 25.69,46.941 25.69,53.82C25.69,60.699 31.351,66.36 38.23,66.36C45.109,66.36 50.77,60.699 50.77,53.82C50.77,53.817 50.77,53.813 50.77,53.81C50.754,46.95 45.12,41.307 38.26,41.28M38.26,60.28C38.257,60.28 38.253,60.28 38.25,60.28C34.717,60.28 31.81,57.373 31.81,53.84C31.81,50.307 34.717,47.4 38.25,47.4C41.783,47.4 44.69,50.307 44.69,53.84C44.69,57.369 41.789,60.275 38.26,60.28",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.74,23.25C38.737,23.25 38.733,23.25 38.73,23.25C21.779,23.25 7.83,37.199 7.83,54.15C7.83,71.101 21.779,85.05 38.73,85.05C55.681,85.05 69.63,71.101 69.63,54.15C69.608,37.211 55.679,23.277 38.74,23.25M38.26,72.93C38.253,72.93 38.247,72.93 38.24,72.93C27.751,72.93 19.12,64.299 19.12,53.81C19.12,43.321 27.751,34.69 38.24,34.69C48.729,34.69 57.36,43.321 57.36,53.81C57.349,64.289 48.739,72.913 38.26,72.94",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.24,47.38C38.237,47.38 38.233,47.38 38.23,47.38C34.697,47.38 31.79,50.287 31.79,53.82C31.79,57.353 34.697,60.26 38.23,60.26C41.763,60.26 44.67,57.353 44.67,53.82C44.67,53.817 44.67,53.813 44.67,53.81C44.67,50.283 41.767,47.38 38.24,47.38",
    style: {
      fill: "rgb(239,105,69)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,47.38C115.813,47.38 115.807,47.38 115.8,47.38C112.267,47.38 109.36,50.287 109.36,53.82C109.36,57.353 112.267,60.26 115.8,60.26C119.333,60.26 122.24,57.353 122.24,53.82L122.24,53.8C122.24,50.278 119.342,47.38 115.82,47.38C115.82,47.38 115.82,47.38 115.82,47.38",
    style: {
      fill: "rgb(3,175,135)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,31.23C148.82,23.49 154.61,15.75 154.61,15.75L128.75,15.75C114.26,6.37 96.65,1.41 77.15,1.41C56.92,1.41 38.65,6.5 24.25,15.92L0,15.93C0,15.93 5.72,23.57 7.58,31.27C2.741,37.892 0.133,45.884 0.133,54.085C0.133,75.299 17.589,92.755 38.803,92.755C50.498,92.755 61.584,87.449 68.92,78.34L77.16,90.68L85.48,78.24C92.81,87.612 104.066,93.098 115.964,93.098C137.194,93.098 154.664,75.628 154.664,54.398C154.664,46.053 151.964,37.927 146.97,31.24M103,82.36C95.533,78.961 89.733,72.703 86.91,65C85.651,61.58 85.006,57.964 85.006,54.32C85.006,37.363 98.959,23.41 115.916,23.41C132.873,23.41 146.826,37.363 146.826,54.32C146.826,71.276 132.873,85.23 115.916,85.23C111.424,85.23 106.985,84.25 102.91,82.36M38.74,85C21.789,85 7.84,71.051 7.84,54.1C7.84,37.149 21.789,23.2 38.74,23.2C55.691,23.2 69.64,37.149 69.64,54.1C69.64,54.103 69.64,54.107 69.64,54.11C69.618,71.051 55.681,84.984 38.74,85M102.48,18C88.305,23.21 78.437,36.281 77.31,51.34C75.847,31.532 59.368,15.898 39.51,15.48C51.434,10.524 64.238,8.034 77.15,8.16C91.04,8.16 103.59,10.67 114.67,15.63C110.505,15.752 106.387,16.553 102.48,18",
    style: {
      fill: "rgb(0,10,18)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.26,34.7C38.253,34.7 38.247,34.7 38.24,34.7C27.751,34.7 19.12,43.331 19.12,53.82C19.12,64.309 27.751,72.94 38.24,72.94C48.729,72.94 57.36,64.309 57.36,53.82C57.36,53.817 57.36,53.813 57.36,53.81C57.338,43.339 48.731,34.727 38.26,34.7M38.26,66.35C38.25,66.35 38.24,66.35 38.23,66.35C31.351,66.35 25.69,60.689 25.69,53.81C25.69,46.931 31.351,41.27 38.23,41.27C45.109,41.27 50.77,46.931 50.77,53.81C50.759,60.674 45.124,66.323 38.26,66.35",
    style: {
      fill: "rgb(0,10,18)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,34.7C115.817,34.7 115.813,34.7 115.81,34.7C105.321,34.7 96.69,43.331 96.69,53.82C96.69,64.309 105.321,72.94 115.81,72.94C126.299,72.94 134.93,64.309 134.93,53.82C134.93,53.817 134.93,53.813 134.93,53.81C134.914,43.333 126.297,34.716 115.82,34.7M115.82,66.35C115.817,66.35 115.813,66.35 115.81,66.35C108.931,66.35 103.27,60.689 103.27,53.81C103.27,46.931 108.931,41.27 115.81,41.27C122.689,41.27 128.35,46.931 128.35,53.81C128.345,60.683 122.693,66.339 115.82,66.35",
    style: {
      fill: "rgb(0,10,18)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripadvisorLogo);
export default __webpack_public_path__ + "static/media/tripadvisorLogo.8a4af5c91d4a6738bb21a7fc56131388.svg";
export { ForwardRef as ReactComponent };